import ReactHtmlParser from "react-html-parser"
import { useState } from "react"
import axios from "axios"
import { UPDATE_PERMISSIONS_TOKEN } from "../../booking/constants/Endpoints"
import Spinner from "../../booking/components/spinner"

export default function ConsentPage({
  consentItems,
  isTokenMissing,
  headerImage,
  imageAltText,
  infoHead,
  header,
  subHeader,
  saveSettingsText,
  thankYouForUpdating,
  brokenLinkMessage,
  updateFailedMessage,
  alreadyUpdatedMessage,
  queryToken,
}) {
  const [consentItemsState, setConsentItemsState] = useState(
    !isTokenMissing && consentItems.permissionList.map((item) => ({ ...item, isChecked: false })),
  )
  const [settingsSaved, setSettingsSaved] = useState(false)
  const [settingsSavedSuccessfully, setSettingsSavedSuccessfully] = useState(false)
  const [spinnerActive, setSpinnerActive] = useState(false)

  const handleCheckboxChange = (index) => {
    const updatedItems = [...consentItemsState]
    updatedItems[index].isChecked = !updatedItems[index].isChecked
    setConsentItemsState(updatedItems)
  }

  const handleSaveSettings = async () => {
    const req = {
      ParkingServicesPermissionVersion: "",
      ParkingServicesPermissionGiven: null,
      NewsletterPermissionVersion: "",
      NewsletterPermissionGiven: null,
      Token: queryToken,
    }
    consentItemsState.forEach((item) => {
      if (item.permissionId === "Parking Consent") {
        req.ParkingServicesPermissionVersion = item.permissionVersion
        req.ParkingServicesPermissionGiven = item.isChecked
      }
      if (item.permissionId === "Marketing Consent") {
        req.NewsletterPermissionVersion = item.permissionVersion
        req.NewsletterPermissionGiven = item.isChecked
      }
    })

    if (!consentItemsState.some((item) => item.isChecked)) {
      console.log("No items checked, not sending request")
      return
    }
    setSpinnerActive(true)
    try {
      const hosts = document.body && document.body.dataset.hosts && JSON.parse(document.body.dataset.hosts)
      const url = UPDATE_PERMISSIONS_TOKEN(hosts)

      axios
        .post(url, req, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then(() => {
          setSettingsSaved(true)
          setSettingsSavedSuccessfully(true)
        })
        .catch((err) => {
          setSettingsSaved(true)
          setSettingsSavedSuccessfully(false)
          console.error("POST error:", err)
        })
        .finally(() => {
          setSpinnerActive(false)
        })
    } catch (err) {
      setSettingsSaved(true)
      setSettingsSavedSuccessfully(false)
      console.error("POST error:", err)
      setSpinnerActive(false)
    }
  }

  return (
    <div className="consent-page">
      <Spinner isActive={spinnerActive} isTransparent={false} />
      <div className="consent-page-header">
        <div className="w--normal consent-page-header-content">
          <div className="consent-page-header-content__text">
            <p className="infohead">{infoHead}</p>
            {ReactHtmlParser(header)}
            <div className="consent-page-header-content__subheader">{ReactHtmlParser(subHeader)}</div>
          </div>
          <div className="consent-page-header-content__image">
            <img tabIndex={imageAltText ? "" : "-1"} aria-hidden={imageAltText ? false : true} src={headerImage} alt={imageAltText} />
          </div>
        </div>
      </div>

      {settingsSaved && !settingsSavedSuccessfully && (
        <div className="consent-page-body__error-message w--normal">{ReactHtmlParser(updateFailedMessage) || "Opdatering fejlede."}</div>
      )}

      {settingsSaved && settingsSavedSuccessfully && (
        <div className="consent-page-body__thank-you w--normal">{ReactHtmlParser(thankYouForUpdating)}</div>
      )}

      {isTokenMissing && (
        <div className="consent-page-body__error-message w--normal">
          {ReactHtmlParser(brokenLinkMessage) || "<p>Der er noget galt med linket, klik på det direkte fra din mail.</p>"}
        </div>
      )}

      {/* user has already updated permissions through other means, but is still valid. */}
      {!isTokenMissing && (!consentItems?.permissionList || consentItems.permissionList.length === 0) && (
        <div className="consent-page-body__thank-you w--normal">{ReactHtmlParser(alreadyUpdatedMessage)}</div>
      )}

      {!settingsSaved && !isTokenMissing && consentItems?.permissionList && consentItems.permissionList.length > 0 && (
        <div className="consent-page-body w--normal">
          <div className="consent-page-body__consent-items">
            {consentItemsState.map((item, index) => (
              <div key={index} className="consent-page-body__consent-item">
                <div className="consent-page-body__consent-item-content">
                  <input type="checkbox" id={`checkbox-${index}`} checked={item.isChecked} onChange={() => handleCheckboxChange(index)} />
                  <label htmlFor={`checkbox-${index}`}>
                    <h2>{ReactHtmlParser(item.texts.headline)}</h2>
                  </label>
                </div>
                <div className="consent-page-body__consent-item-description rich-text">{ReactHtmlParser(item.texts.bodyTextRich)}</div>
              </div>
            ))}
          </div>

          <div className="consent-page-body__button-container">
            <button onClick={handleSaveSettings} disabled={!consentItemsState.some((item) => item.isChecked)}>
              {saveSettingsText}
            </button>
          </div>
        </div>
      )}
    </div>
  )
}
